export default function OQueVoceRecebe() {
  const captures = [
    { name: 'Driftwood Purple Nightmare', count: 30 },
    { name: 'ENGL Powerball', count: 30 },
    { name: 'ENGL Savage', count: 18 },
    { name: 'EVH 5150 Iconic', count: 22 },
    { name: 'KSR Ceres', count: 4 },
    { name: 'Marshall JCM 800', count: 19 },
    { name: 'Mesa Boogie Dual Rectifier', count: 18 },
    { name: 'Mesa Boogie Dual Rectifier RoadKing', count: 18 },
    { name: 'Randall Thrasher', count: 3 },
    { name: 'Universal Audio ANTI', count: 7 },
    { name: 'Universal Audio Knuckles', count: 5 }
  ];

  return (
    <section className="relative py-24 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-6xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <div className="inline-block bg-orange-500 px-6 py-2 mb-6">
            <span className="text-3xl font-black text-black">174 CAPTURES PROFISSIONAIS</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            O que você recebe
          </h2>
          <p className="text-xl text-gray-400">
            Arsenal completo de high gain profissional
          </p>
        </div>

        {/* Captures List */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {captures.map((capture, index) => (
            <div
              key={index}
              className="group flex items-center justify-between bg-zinc-950 border border-zinc-800 hover:border-orange-500 p-6 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500/10 group-hover:bg-orange-500 transition-colors duration-300">
                  <i className="ri-guitar-fill text-2xl text-orange-500 group-hover:text-black"></i>
                </div>
                <span className="text-lg font-bold text-white group-hover:text-orange-500 transition-colors duration-300">
                  {capture.name}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-2xl font-black text-orange-500">
                  {capture.count}
                </span>
                <span className="text-sm text-gray-500 uppercase tracking-wider">
                  captures
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-zinc-950 border border-zinc-800 p-6 text-center">
            <i className="ri-download-cloud-fill text-4xl text-orange-500 mb-4"></i>
            <h3 className="text-lg font-bold text-white mb-2">Download Imediato</h3>
            <p className="text-sm text-gray-400">Acesso instantâneo após a compra</p>
          </div>
          <div className="bg-zinc-950 border border-zinc-800 p-6 text-center">
            <i className="ri-file-music-fill text-4xl text-orange-500 mb-4"></i>
            <h3 className="text-lg font-bold text-white mb-2">Formato Nativo</h3>
            <p className="text-sm text-gray-400">Compatível com Ampero II</p>
          </div>
          <div className="bg-zinc-950 border border-zinc-800 p-6 text-center">
            <i className="ri-shield-check-fill text-4xl text-orange-500 mb-4"></i>
            <h3 className="text-lg font-bold text-white mb-2">Qualidade Pro</h3>
            <p className="text-sm text-gray-400">Testado em estúdio e palco</p>
          </div>
        </div>
      </div>
    </section>
  );
}
